const editProfileInfoDictES = {
  choose: "Elegir",
  cancel: "Cancelar",
  dragImgFile: "Arrastre el archivo de imagen aquí",
  zipCode: "Código Postal",
  country: "País",
  state: "Estado",
  city: "Ciudad",
  publicPlace: "Calle",
  district: "Barrio",
  number: "Número",
  countryPhoneCode: "Cód. de Tel. del País",
  regionalPhoneCode: "Cód. de Tel. Regional",
  phoneNumber: "Número de Tel.",
  changeProfilePic: "Cambiar Foto de Perfil",
  confirmProfileChanges: "Confirmar cambios en el Perfil",
  // toast
  pleaseChoosePfp: "Por favor elija una foto de perfil primero.",
  fileSizeTooBig: "El tamaño del archivo es muy grande (excede 2 MB).",
  unexpectedErrorUploadImg: "Error inesperado al cargar la imagen.",
  usernameCantBeEmpty:
    "El nombre de usuario debe contener únicamente letras minúsculas y números. No puede estar vacío ni contener espacios.",
  usernameNotAvailable: "Nombre de usuario no disponible.",
  unexpectedErrorChangingPfp: "Error inesperado al cambiar el perfil.",
  sucessfullyEditedProfile: "Perfil editado con éxito.",
  unexpectedSystemBehaviour: "Comportamiento inesperado del sistema.",
  canRetriveOnSaturdays: "¿El servicio de envío puede recoger el pedido los sábados?",
  quantityOfDaysToRetrive:
    "Cantidad de días para que el servicio de envío recoja su pedido y lo lleve a su destino",
  settingsPageTitle: "Configuración",
  settingsPageProfileInfoTitle: "Información de perfil",
  settingsPageSubtitle: "Gestione sus preferencias y opciones.",
  upgradeAccount: "Mejorar cuenta",
  logout: "Cerrar sesión",
  settingsTabGeneral: "Configuración general",
  settingsTabProfile: "Configuración de perfil",
  profileSettingsSubtitle: "Actualice su perfil y preferencias de envío.",
  settingsTabPrivacy: "Privacidad y seguridad",
  settingsMenuSelection: "Menú de selección",
  regionalPreferences: "Preferencias regionales",
  regionalPreferencesSubtitle: "Seleccione las preferencias para su región.",
  language: "Idioma",
  timezone: "Zona horaria",
  timeFormatOptional: "Formato de hora (Opcional)",
  dateFormatOptional: "Formato de fecha (Opcional)",
  hours: "horas",
  contactInfo: "Información de contacto",
  contactInfoSubtitle: "Indique su teléfono y dirección.",
  applyChanges: "Aplicar modificaciones",
  confirm: "Confirmar",
  changePassword: "Cambiar contraseña",
  changePasswordSubtitle: "Actualice la contraseña para mayor seguridad.",
  currentPassword: "Contraseña actual",
  newPassword: "Nueva contraseña",
  confirmPassword: "Confirmar nueva contraseña",
  passwordMustContainAtLeast: "Debe contener al menos:",
  passwordRequirementUppercase: "1 letra mayúscula",
  passwordRequirementNumber: "1 número",
  passwordRequirementLength: "8 caracteres",
  passwordStrengthNone: "",
  passwordStrengthWeak: "Débil",
  passwordStrengthMedium: "Media",
  passwordStrengthStrong: "Fuerte",
  loading: "Cargando...",
  deleteAccount: "Eliminar cuenta",
  deleteAccountSubtitle: "Gestione el proceso de cancelación de la cuenta.",
  deleteAccountWarning: "Esta acción no se puede deshacer.",
  deleteAccountInfo: "Todos sus datos serán eliminados permanentemente.",
  writeCancelToConfirm: "Escriba CANCELAR para confirmar",
  confirmYourPassword: "Confirme su contraseña",
  passwordChangedSuccessfully: "Contraseña cambiada correctamente.",
  accountCanceledSuccessfully: "Cuenta cancelada correctamente.",
  passwordFieldsMismatched: "Las contraseñas no coinciden.",
  cancelAccountError: "Error al cancelar la cuenta.",
  firstName: "Nombre",
  surname: "Apellido",
  username: "Nombre de usuario",
  uploadImage: "Cargar imagen",
  freight: "Envío",
  select: "Seleccionar",
  profileAnalysisTab: "Análisis de perfil",
  profileAnalysisMenuItem: "Análisis de perfil",
  profileAnalysisTitle: "Análisis del Perfil y de los Objetivos",
  profileAnalysisSubtitle:
    "Responde a estas breves preguntas para ayudarnos a entender tus objetivos.",
  profileAnalysisAddress: "Dirección",
  profileAnalysisAddressHelp: "Introduce tu dirección de residencia actual.",
  profileAnalysisNationality: "Nacionalidad",
  profileAnalysisBirthPlace: "Lugar de Nacimiento",
  profileAnalysisBirthDate: "Fecha de Nacimiento",
  profileAnalysisBirthDatePlaceholder: "DD/MM/AAAA",
  profileAnalysisPhone: "Teléfono",
  profileAnalysisEmail: "E-mail",
  profileAnalysisEmployment: "Actividad Laboral",
  profileAnalysisMaritalStatus: "Estado Civil",
  profileAnalysisEducationLevel: "Nivel de Estudios",
  profileAnalysisHouseholdMembers: "Miembros del Núcleo Familiar",
  profileAnalysisObjectives: "Objetivos",
  profileAnalysisNeeds: "Necesidades",
  profileAnalysisDateLabel: "Fecha: ",
  profileAnalysisConsultantLabel: "Consultor: ",
  profileAnalysisNoData: "—",
  profileAnalysisConsentLabel: "Consiento",
  profileAnalysisConsentText:
    "La información se utilizará para elaborar una evaluación gratuita para la plataforma EXTRACONOMY.",
  profileAnalysisSendDiagnosis: "Enviar Diagnóstico",
  profileAnalysisUpdateDiagnosis: "Actualizar Diagnóstico",
  profileAnalysisSubmitSuccess: "Diagnóstico enviado con éxito.",
  profileAnalysisMaritalSingle: "Soltero/a",
  profileAnalysisMaritalMarried: "Casado/a",
  profileAnalysisMaritalDivorced: "Divorciado/a",
  profileAnalysisMaritalWidowed: "Viudo/a",
  profileAnalysisMaritalCivilUnion: "Unión civil",
  profileAnalysisMaritalSeparated: "Separado/a",
};

export default editProfileInfoDictES;
